import finalStepImage from "../../Assets/images/final-step.png";
import { useNavigate } from "react-router-dom";

export const SuccessfullStep = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center mt-5">
            <img src={finalStepImage} width={172} height={200} alt="" />
          </div>
          <div className="authcardmain pt-5 mt-2">
            <div className="authcardheader text-center">
              <p className="white-font fw-normal font-14 authcardsubtitle">
                Your Password has been reset
              </p>
              <span className="h_1 white-font fw-medium mt-3 pt-1 d-inline-block">
                Successfully
              </span>
            </div>
            <button type="submit" onClick={() => {navigate("/login")}} className="btn-primary-custom w-100 mt-4">
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
